import Vue from 'vue'
import { VTooltip } from 'v-tooltip'
import GcModal from './components/shared/GcModal'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate/dist/vee-validate.full';
import { required, min, email } from 'vee-validate/dist/rules';
import Multiselect from 'vue-multiselect'
import VueI18n from 'vue-i18n'
import VuePluralize from 'vue-pluralize'


import sign_up_form_translations from '@/translations/sign_up_form/index'

const tooltipOptions = (currentApp) => {
	if (currentApp === 'tutorialEditorApp') {
		return {
			defaultPlacement: 'right-end',
			defaultDelay: 100,
			defaultContainer: 'body'
		}
	}
	return {};
}

Vue.use(VueI18n)
Vue.use(VuePluralize)

const messages = {
	en: {},
	de: {},
	fr: {},
	it: {},
	es: {},
	ja: {},
	ko: {},
	ru: {},
	'zh-CN': {},
	'zh-TW': {}
};

Object.keys(sign_up_form_translations).forEach((key) => {
	messages[key]['sign_up_form'] = sign_up_form_translations[key];
});

const i18n = new VueI18n({
	locale: Grabcad.locale || 'en',
	messages: messages
});

extend('required', {
	...required,
	message: '{_field_} ' + i18n.t('sign_up_form.error.blank')
});

extend('min', {
	...min,
	message: '{_field_} must be at least {length} characters'
});

extend('min_password', {
	...min,
	message: i18n.t("sign_up_form.error.password_short")
})

extend('email', {
	...email,
	message: i18n.t('sign_up_form.error.email_look')
})


Vue.component('GcModal', GcModal);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('Multiselect', Multiselect);

Vue.directive('tooltip', VTooltip);

import store from './store'
import componentsRegistries from './helpers/componentsRegistries'
import detectApps from './helpers/detectApps'
import currentApp from './helpers/currentApp'
import createDirectives from './directives/directives'
import gcOpentoworkDialog from './components/shared/gcOpentoworkDialog'
import gcOpentoworkNavicon from './components/shared/gcOpentoworkNavicon'
import gcOpentoworkSwitch from './components/shared/gcOpentoworkSwitch'
import gcOpentoworkTooltip from './components/shared/gcOpentoworkTooltip'
import GcAdsenseModal from './components/shared/adsense/GcAdsenseModal'

Vue.prototype.$eventHub = new Vue();
Vue.config.productionTip = false;

createDirectives(Vue);

const apps = detectApps();

apps.forEach(appId => {
	Vue.use(VTooltip, tooltipOptions(appId));
	new Vue({
		store,
		...currentApp(appId),
		i18n,
		components: {
			...componentsRegistries(appId),
			gcOpentoworkDialog,
			gcOpentoworkNavicon,
			gcOpentoworkSwitch,
			gcOpentoworkTooltip,
			GcAdsenseModal,
			ValidationProvider
		}
	}).$mount(`#${appId}`)
});
